var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89676 0.635568L3.88221 3.83852C3.67498 4.05872 3.32505 4.05872 3.11781 3.83852L0.10324 0.635568C-0.123248 0.394898 0.0473608 0 0.377841 0H6.62213C6.95264 0 7.12325 0.394898 6.89676 0.635568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowIcon);
export default __webpack_public_path__ + "static/media/sort-arrow-icon.09e4f9aea36ebc8d8e64bce0daff7304.svg";
export { ForwardRef as ReactComponent };